import { ArrowDropDown, ArrowRight } from '@material-ui/icons';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import ResourceEvent from './ResourceEvent';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

const ResourceRow = (props) => {
  const { classes } = props;

  const styleRef = useRef();
  const { resourceItem, events, handlePopoverOpen } = props;

  const [open, setopen] = useState(true);

  // Determines if the platform specific toggle selection in group key was used
  const wasToggleInSelectionGroupKeyUsed = (event) => {
    const isUsingWindows = navigator.platform.indexOf('Win') >= 0;
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  // Determines if the multiSelect key was used
  const wasMultiSelectKeyUsed = (event) => event.shiftKey;
  const toopTiptext = (
    <span>
      {' '}
      Faculty: <br />
      subject: <br />
      venue:
    </span>
  );

  // const performAction = (event) => {
  //   const { task, toggleSelection, toggleSelectionInGroup, multiSelectTo } =
  //     props;

  //   if (wasToggleInSelectionGroupKeyUsed(event)) {
  //     toggleSelectionInGroup(task.id);
  //     return;
  //   }

  //   if (wasMultiSelectKeyUsed(event)) {
  //     multiSelectTo(task.id);
  //     return;
  //   }

  //   toggleSelection(task.id);
  // };

  // const onClick = (event) => {
  //   if (event.defaultPrevented) {
  //     return;
  //   }

  //   event.preventDefault();

  //   performAction(event);
  // };

  // const onTouchEnd = (e) => {
  //   console.log('onTouchEnd event called!!!');
  // };

  return (
    <>
      <tr onClick={() => setopen(!open)}>
        <td
          width={150}
          className="mark"
          style={{
            whiteSpace: 'nowrap',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {open ? <ArrowDropDown /> : <ArrowRight />}
            {resourceItem.name}
          </div>
        </td>
        <td colSpan={12} style={{ width: 600 }} className="mark"></td>
      </tr>

      {resourceItem.children.map((resourceChild) => {
        const currentEvents = events?.filter(
          (evt) => evt.resourceId === resourceChild.id
        );

        return (
          // <Droppable key={resourceChild.id} droppableId={resourceChild.id}>
          //   {(provided, snapshot) => (
          <tr
            // ref={provided.innerRef}
            // isDraggingOver={snapshot.isDraggingOver}
            // {...provided.droppableProps}
            style={{ display: open ? '' : 'none' }}
          >
            {/* {console.log('name', resourceChild.name)} */}
            <td width={150} className="mark" style={{ paddingLeft: '24px' }}>
              {resourceChild.name}
            </td>

            {new Array(12).fill().map((_, i) => {
              const dataHour = i + 7;
              return (
                <td
                  key={`${resourceChild.id}-${dataHour}`}
                  className={`rt-cell ${resourceChild.id}-${dataHour}`}
                  data-hour={dataHour}
                  data-resourceid={resourceChild.id}
                  ref={styleRef}
                >
                  {currentEvents?.map((evt, index) => {
                    // const hours = moment(evt.end).diff(moment(evt.start));
                    // const width = hours * 40;
                    // console.dir(styleRef.current);

                    return moment(evt.start).hour() === dataHour ? (
                      // <Draggable draggableId={`${evt.id}`} index={index}>
                      //   {(provided, snapshot) => (
                      <div
                        // onClick={onClick}
                        // onTouchEnd={onTouchEnd}
                        // ref={provided.innerRef}
                        // {...provided.draggableProps}
                        // {...provided.dragHandleProps}
                        key={evt.id}
                        id="link1"
                        className="box drag t1 tooltip "
                        data-event-hours={evt.hours}
                        data-evtid={evt.id}
                        style={{
                          width: `${evt.hours * 42}px`,
                          height: '30px',
                          overflow: 'hidden',
                          border: '1px solid rgb(204, 209, 216)',
                          whiteSpace: 'nowrap',
                          verticalAlign: 'middle',
                          lineHeight: 1.8,
                          backgroundColor: evt.bgColor,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        // onMouseOver={(e) => handlePopoverOpen(e)}
                      >
                        <Tooltip title={toopTiptext} placement="bottom">
                          <Button> {evt.title}</Button>
                        </Tooltip>
                        {/* {console.log('title', evt.title, dataHour)} */}{' '}
                      </div>
                    ) : (
                      //   )}
                      // </Draggable>
                      <div
                        style={{
                          width: `${40}px`,
                        }}
                      ></div>
                    );
                  })}
                </td>
              );
            })}
          </tr>
          //   )}
          // </Droppable>
        );
      })}
    </>
  );
};

export default ResourceRow;
